<template>
  <div class="m-cont">
    <div class="nav-sale">
      <div class="con-sal">
        <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
      </div>
      DIGITALIZZAZIONE MENU
    </div>

    <div class="content-form-map">
      <!-- Upload and Options Section -->
      <div class="main-tab">
        <h5>Opzioni e Caricamento</h5>
        <div class="filters">
          <div class="lang-selector mb-3">
            <p>Lingue da estrarre:</p>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="it" value="it" v-model="selectedLangs" disabled>
              <label class="form-check-label" for="it">Italiano (it) - Default</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="en" value="en" v-model="selectedLangs">
              <label class="form-check-label" for="en">Inglese (en)</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="es" value="es" v-model="selectedLangs">
              <label class="form-check-label" for="es">Spagnolo (es)</label>
            </div>
          </div>

          <div class="upload-actions">
            <input type="file" ref="fileInput" @change="handleFileUpload" accept=".pdf,image/*" style="display: none" />
            <input type="file" ref="cameraInput" @change="handleFileUpload" accept="image/*" capture="environment" style="display: none" />

            <div class="d-grid gap-2">
              <button class="btn btn-primary" @click="$refs.cameraInput.click()" :disabled="isLoading">
                📸 Scatta Foto Menu
              </button>
              <button class="btn btn-info text-white" @click="$refs.fileInput.click()" :disabled="isLoading">
                📁 Gallery / PDF
              </button>
            </div>
          </div>

          <div v-if="isLoading" class="mt-4 text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">{{ loadingMessage }}</p>
          </div>
        </div>
      </div>

      <!-- Results Table Section -->
      <div class="main-map">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5>Piatti Estratti</h5>
          <div v-if="extractedItems.length > 0">
            <button class="btn btn-success btn-sm" @click="confirmAll" :disabled="isSaving">
              {{ isSaving ? 'Salvataggio...' : 'Conferma e Salva Tutto' }}
            </button>
          </div>
        </div>

        <div v-if="extractedItems.length === 0 && !isLoading" class="text-center py-5 text-muted">
          <p>Carica un'immagine o un PDF per iniziare la digitalizzazione.</p>
        </div>

        <div v-if="extractedItems.length > 0" class="table-responsive">
          <table class="table table-hover border">
            <thead class="table-light">
              <tr>
                <th>Nome (IT)</th>
                <th v-if="selectedLangs.includes('en')">Nome (EN)</th>
                <th v-if="selectedLangs.includes('es')">Nome (ES)</th>
                <th>Prezzo (€)</th>
                <th>Descrizione (IT)</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in extractedItems" :key="index">
                <td><input type="text" v-model="item.nome" class="form-control form-control-sm"></td>
                <td v-if="selectedLangs.includes('en')">
                  <input type="text" v-model="item.nomeEn" class="form-control form-control-sm">
                </td>
                <td v-if="selectedLangs.includes('es')">
                  <input type="text" v-model="item.nomeEs" class="form-control form-control-sm">
                </td>
                <td><input type="number" step="0.01" v-model="item.prezzo" class="form-control form-control-sm" style="width: 80px;"></td>
                <td><textarea v-model="item.descrizione" class="form-control form-control-sm" rows="1"></textarea></td>
                <td>
                  <button class="btn btn-outline-danger btn-sm" @click="removeItem(index)">&times;</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'Digitalizzazione',
  data() {
    return {
      store,
      selectedLangs: ['it'],
      isLoading: false,
      isSaving: false,
      loadingMessage: '',
      digitizationId: null,
      extractedItems: [],
      pollingInterval: null
    }
  },
  methods: {
    home() {
      this.$router.push({ name: "Gestionale" })
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.isLoading = true;
      this.loadingMessage = 'Caricamento file...';
      this.extractedItems = [];

      const formData = new FormData();
      formData.append('file', file);
      formData.append('languages', JSON.stringify(this.selectedLangs));

      try {
        const response = await this.axios.post(this.store.path + 'digitizzazione/upload', formData, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });

        this.digitizationId = response.data.digitizationId;
        this.startPolling();
      } catch (error) {
        console.error('Upload error:', error);
        alert('Errore durante il caricamento del file.');
        this.isLoading = false;
      }
    },
    startPolling() {
      this.loadingMessage = 'Analisi del menu in corso (AI)...';
      this.pollingInterval = setInterval(async () => {
        try {
          const response = await this.axios.get(this.store.path + 'digitizzazione/status/' + this.digitizationId, {
            headers: {
              authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
          });

          if (response.data.stato === 'PROCESSED') {
            this.stopPolling();
            this.extractedItems = response.data.items;
            this.isLoading = false;
          } else if (response.data.stato === 'ERROR') {
            this.stopPolling();
            alert('Errore durante l\'elaborazione AI del menu.');
            this.isLoading = false;
          }
        } catch (error) {
          console.error('Polling error:', error);
          this.stopPolling();
          this.isLoading = false;
        }
      }, 3000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    removeItem(index) {
      this.extractedItems.splice(index, 1);
    },
    async confirmAll() {
      if (this.extractedItems.length === 0) return;
      
      this.isSaving = true;
      try {
        await this.axios.post(this.store.path + 'digitizzazione/confirm', {
          digitizationId: this.digitizationId,
          items: this.extractedItems
        }, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });

        alert('Menu salvato correttamente!');
        this.$router.push({ name: 'EditMenu' });
      } catch (error) {
        console.error('Confirm error:', error);
        alert('Errore durante il salvataggio del menu.');
      } finally {
        this.isSaving = false;
      }
    }
  },
  beforeUnmount() {
    this.stopPolling();
  }
}
</script>

<style scoped>
.m-cont {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding-bottom: 50px;
}

.nav-sale {
  padding: 15px;
  background: #343a40;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-weight: bold;
  font-size: 1.2rem;
}

.content-form-map {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
}

.main-tab {
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  height: fit-content;
}

.main-map {
  flex: 3;
  min-width: 500px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.lang-selector {
  background: #f1f3f5;
  padding: 15px;
  border-radius: 8px;
}

.lang-selector p {
  font-weight: bold;
  margin-bottom: 10px;
}

.table th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  font-size: 0.9rem;
}

@media (max-width: 992px) {
  .content-form-map {
    flex-direction: column;
  }
  .main-tab {
    max-width: 100%;
  }
}
</style>
